/**
 * Colour tokens, resolved where a value must be a colour and cannot be a CSS
 * variable (Leaflet draws its pins as SVG attributes, and the pace scale is
 * interpolated in numbers). Every colour is defined once in index.css; this
 * only reads it (round 3: components name tokens, never colours).
 */
export function tokenColour(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(`--color-${name}`).trim();
}

/** A token's colour as [r, g, b], for interpolating between two. */
export function tokenRgb(name: string): [number, number, number] {
  const hex = tokenColour(name).replace('#', '');
  return [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16)) as [number, number, number];
}

/**
 * A place's colour on the visits board and map, from its clients' average pace,
 * on a FIXED scale between two tokens (pace-low, pace-full); pace-none where
 * nobody owes a visit. Shared by the board and the map, so a colour means the
 * same pace on both.
 */
export function paceColour(averagePace: number | null): string {
  if (averagePace === null) return tokenColour('pace-none');
  const low = tokenRgb('pace-low');
  const full = tokenRgb('pace-full');
  const t = Math.min(Math.max(averagePace, 0), 1);
  const [r, g, b] = low.map((v, i) => Math.round(v + (full[i]! - v) * t));
  return `rgb(${r}, ${g}, ${b})`;
}
